class ProductTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(document, 'click', this.handleClick)
  }

  handleClick (event) {
    const clickedTrigger = event.target.closest(this.els.trigger.selector)

    if (!clickedTrigger) return

    const matchElement = document.querySelector(
      `[data-product-tabs-external-el="${clickedTrigger.dataset.element}"]`,
    )

    if (!matchElement) return

    matchElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs)
}
